module.exports = __webpack_public_path__ + "img/eye.08a3f130.svg";